import React from 'react';

function HistoryItemW({ item, no }) {
    return (
        <tr>
            <td>{no}</td>
            <td>{item.p_name}</td>
            <td>{item.p_price}</td>
            <td>{item.p_sale}</td>
            <td>{item.date}</td>
            <td>{item.p_remain}</td>
        </tr>
    );
}
export default HistoryItemW;
